module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "CN",
    attrs: {
      "id": "ch001"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch-001"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER ONE")])])]), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch-001"
    }
  }, [_vm._v("Jesus according to")])]), _vm._v(" "), _c('p', {
    staticClass: "CT1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch-001"
    }
  }, [_vm._v("Jesus")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("C")]), _vm._v("an we be confident that we are able to get back to Jesus’s own message and views of himself? John Meier certainly has no doubts on the subject—and the five volumes of "), _c('i', [_vm._v("A Marginal Jew: Rethinking the Historical Jesus")]), _vm._v(" include a clear and fully worked-out answer."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1",
      "id": "fn1"
    }
  }, [_vm._v("1")])]), _vm._v(" Perhaps, however, a briefer answer will help focus attention on the key features that enable us to speak with confidence not only of the impact that Jesus made but also of Jesus’s own understanding of what he was about. The obvious way to go about it is to focus on the distinctive features of what the first Christians remembered about Jesus as recorded by the earliest evangelists."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn2",
      "id": "fn2"
    }
  }, [_vm._v("2")])]), _vm._v(" The following pages explore this in three ways: lessons learned from Jesus, distinctive features of Jesus’s ministry, and Jesus’s own self-understanding."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn3",
      "id": "fn3"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("Lessons Learned from Jesus")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("There are quite a number of emphases and priorities that we can say with some confidence the first followers of Jesus attributed to Jesus.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Love Command")])]), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("The summation of the love command is recorded by the first three Gospels."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn4",
      "id": "fn4"
    }
  }, [_vm._v("4")]), _vm._v(" Since all three agree on the principal features, we need cite only Mark’s version:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("One of the scribes . . . asked him, “Which commandment is the first of all?” Jesus answered, “The first is, ‘Hear, O Israel: the Lord our God, the Lord is one; and you shall love the Lord your God with all your heart. . . .’ The second is this, ‘You shall love your neighbor as yourself.’ There is no other commandment greater than these.” (Mark 12:28–31)"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn5",
      "id": "fn5"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("The first quotation comes from Deuteronomy 6:5, the fundamental creed of Israel, so it would occasion no surprise to those who first heard and circulated the Jesus tradition. It is the second commandment that would be something of a surprise when first uttered. For it comes from a much less well-known and less-used passage in the Torah: Leviticus 19:18. In early Jewish reflection it is hardly as prominent as the first—the third clause in a verse that is part of a sequence regarding personal relationships and obligations. “You shall not hate in your heart anyone of your kin; you shall reprove your neighbor, or you will incur guilt yourself. You shall not take vengeance or bear a grudge against any of your people, but you shall love your neighbor as yourself: I am the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("” (Lev 19:17–18).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("Such esteem for Leviticus 19:18c as the second of the two commandments that sum up the law of God is exceptional. Explicit references to Leviticus 19:18 are lacking in Jewish literature prior to Jesus, and the allusions that exist give it no particular prominence—though, subsequently, the opinion is attributed to Rabbi Akiba (early second century CE) that Leviticus 19:18 is “the greatest general principle in the Torah.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn6",
      "id": "fn6"
    }
  }, [_vm._v("6")]), _vm._v(" Since the prominence given in the earliest history of Christianity to the command to “Love your neighbor as yourself”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn7",
      "id": "fn7"
    }
  }, [_vm._v("7")])]), _vm._v(" is most obviously attributed to the influence of Jesus’s teaching, it is probably not unfair to deduce that the similar emphasis of Akiba attests the same influence. At any rate, the abstraction and exaltation of Leviticus 19:18c as the second of the two greatest commandments can be confidently attributed to Jesus and strongly attests his influence.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Priority of the Poor")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This priority is most striking in several Gospel passages. Notable is Jesus’s response to the rich young man, who had observed all the commandments but lacked one thing: “Go, sell what you own, and give to the poor, and you will have treasure in heaven” (Mark 10:21 parr.). Similarly his commendation of the poor widow who in giving two copper coins to the treasury had, in Jesus’s perspective, “out of her poverty . . . put in everything she had, all she had to live on” (Mark 12:42–44 // Luke 21:2–4). In Jesus’s response to the Baptist’s question as to whether he (Jesus) was the fulfillment of (messianic) expectation, the climax in Jesus’s answer is that “the poor have good news brought to them” (Matt 11:5 // Luke 7:22). Notable too is the way Luke begins his account of Jesus’s mission, by narrating Jesus’s reading from Isaiah 61 in the Nazareth synagogue: “The Spirit of the Lord is upon me, because he has anointed me to preach good news to the poor” (Luke 4:18). And "), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("equally striking is Luke’s version of the Beatitudes—the first being “Blessed are you who are poor, for yours is the kingdom of God” (Luke 6:20; an interesting variation of the version in Matthew: “Blessed are the poor in spirit” [Matt 5:3]). It should occasion little surprise, then, that for Luke a key feature of the gospel is that it is good news for the poor: that it is the poor, the maimed, the lame, and the blind who should be invited to a great feast (Luke 14:13, 21); and Zacchaeus demonstrates his readiness for salvation in that he gives half of his goods to the poor (Luke 19:8).")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("Of course, the priority of the poor is a prominent emphasis within Israel’s own law (e.g., Deut 15:11). But that the particular concern for the poor so prominent among the first Christians is to be attributed to the influence of Jesus’s own emphasis can hardly be doubted. So with the early concern among disciples in the Jerusalem community for the poor widows among their members that resulted in the first formal Christian organization (Acts 6:1–6). The profound concern for the poor displayed by James attests the same concern (Jas 2:2–6). The same impression is given by the fact that in the Jerusalem agreement—that gentile converts need not be circumcised—the only other concern indicated was “that we remember the poor, which,” Paul adds, “was actually what I was eager to do” (Gal 2:10). Similarly there can be little doubt as to why Paul gave such importance to helping the poor among the saints in Jerusalem, making a special collection for them in the churches that he had founded, and was willing to risk his own life to bring the collection to Jerusalem."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn8",
      "id": "fn8"
    }
  }, [_vm._v("8")]), _vm._v(" We may be confident, then, that concern for the poor is one of the priorities that the first Christians learned from Jesus.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Sinners Welcome")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("A particular feature of Jesus’s ministry that caused surprise and shock to his religious contemporaries was his openness to those regarded as unacceptable in religious company. According to the "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("first three Gospels, it was one of the features of Jesus’s conduct that drew criticism from the “righteous.” Early in his account Mark reports the offense Jesus caused by his readiness to eat “with sinners and tax collectors.” “Why does he do this?” complained Pharisees and scribes. To which Jesus famously replied, “Those who are well have no need of a physician, but those who are sick; I have come to call not the righteous but sinners” (Luke adds “. . . to repentance”; Mark 2:16–17 parr.). Matthew and Luke (Q)"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn9",
      "id": "fn9"
    }
  }, [_vm._v("9")]), _vm._v(" note a similar criticism later: “Look, a glutton and a drunkard, a friend of tax collectors and sinners!” (Matt 11:19 // Luke 7:34). But it is again Luke who gives particular emphasis to this aspect of Jesus’s conduct. He notes the repeated criticism of Jesus on this point: “This fellow welcomes sinners and eats with them” (Luke 15:2). To which Jesus replies with the parables of the shepherd’s lost sheep and the woman’s lost silver coin: that of course the shepherd goes in search of the sheep and the woman for the coin until they find what had been lost (Luke 15:3–10). Luke alone narrates the parable contrasting the prayers of the Pharisee and the tax collector, in which it is the latter who prays, “God, be merciful to me a sinner,” whose prayer is truly heard (Luke 18:9–14). And it is Luke alone who narrates the episode in which Jesus goes to be a guest with the “chief tax collector,” Zacchaeus, despite the criticism that Zacchaeus was “a sinner.” The episode ends with Jesus’s reassurance that salvation has come to this house, since he (Zacchaeus) also is a son of Abraham (Luke 19:1–10).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is hardly surprising, then, that Paul could sum up the gospel in terms of the great reversal—of God’s love for "), _c('i', [_vm._v("sinners")]), _vm._v(". “God proves his love for us in that while we still were sinners Christ died for us” (Rom 5:8). “For just as by the one man’s disobedience the many were made sinners, so by the one man’s obedience the many will be made righteous” (Rom 5:19). And it was Paul who pressed the logic of the gospel: that if gentiles are to be classified as “sinners,” then, of course, the gospel is for them too, justification being by faith in Christ and not by doing the works of the law (Gal "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("2:15–17). It can hardly be doubted that this extension of the gospel, to gentiles as well as Jews, was the direct result of the recognition that the good news that Jesus brought was primarily for sinners.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "H2"
  }, [_vm._v("Openness to Gentiles")])]), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Jesus’s commission of his disciples, in effect to join in his ministry, raises the question whether Jesus himself was open to gentiles: “Go nowhere among the Gentiles, and enter no town of the Samaritans, but go rather to the lost sheep of the house of Israel” (Matt 10:5–6). But Matthew records this as in effect simply a (preliminary) phase in Jesus’s ministry, since he takes more pains to emphasize that Jesus saw the gospel as for gentiles also. It is Matthew alone who provides Isaiah 42:1–4 as one of the Old Testament prophecies that Jesus fulfilled, climaxing in the expectation that “in his [Christ’s] name the Gentiles will hope” (Matt 12:21). It is Matthew who adds to the account of the healing of the centurion’s servant the prediction of Jesus that “many will come from east and west and will eat with Abraham and Isaac and Jacob in the kingdom of heaven, while the heirs of the kingdom will be thrown into the outer darkness” (Matt 8:11–12). And it is Matthew who ends his Gospel with Jesus commissioning the apostles to “Go therefore and make disciples of all nations” (Matt 28:19). So we can be confident that Matthew was fully in accord with the early Christian conviction that the gospel was also for gentiles and that this conviction was fully in accord with Jesus and with his preaching and expectation during his earthly ministry."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn10",
      "id": "fn10"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Women among His Close Followers")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Somewhat oddly Mark concludes his account of Jesus’s crucifixion and death by noting that on the edge of the onlookers were "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("women, Mary Magdalene, Mary the mother of James the younger and of Joses, and Salome, who had followed and ministered to him in Galilee, and also “many other women who had come up with him to Jerusalem” (Mark 15:40–41)."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn11",
      "id": "fn11"
    }
  }, [_vm._v("11")]), _vm._v(" The oddity, of course, includes the fact that precisely at this point Jesus’s male disciples seem to have abandoned Jesus altogether—though John adds that “the disciple whom Jesus loved” was there with the women (John 19:25–27). Luke and John earlier both tell the touching story of Jesus’s closeness to the sisters Martha and Mary (Luke 10:38–42; John 11). And Matthew and John make special mention of initial resurrection appearances to Mary Magdalene in particular at Jesus’s now empty tomb."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn12",
      "id": "fn12"
    }
  }, [_vm._v("12")])]), _vm._v(" The fact that none of these appearances are included in what we may regard as the formal list of resurrection appearances drawn on by Paul in 1 Corinthians 15:3–8 is presumably just a reminder that women’s testimony was not given as much weight as men’s. It is all the more notable, therefore, that, despite what was regarded as the weaker status of women’s testimony, Matthew and John nevertheless give prominence to the appearances to Mary Magdalene in particular.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("That this testimony would have been regarded as shocking to Jesus’s contemporaries may well have been a factor in ensuring that the testimony was preserved and given expression in the written Gospels—a reminder that women were an important part of Jesus’s disciple group and played a vital role within it. And should we not see a connection here with the prominence of women among Paul’s coworkers? That the ex-Pharisee, previously committed to the maintenance of Jewish tradition, including the lower status of women, should after his conversion include many women among his close colleagues and “coworkers,” a little over 20 percent,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn13",
      "id": "fn13"
    }
  }, [_vm._v("13")])]), _vm._v(" should probably be regarded as an indication of the often unmentioned influence of the tradition of Jesus’s ministry on Paul.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Openness to Children")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("The key incident recollected by the first three Gospels is Mark 10:13–16 parr. Notable is the fact, recorded by all three evangelists, that when people brought children to Jesus, that he might bless the children, his disciples rebuked them. Jesus’s own indignant response was, “Let the children come to me; do not stop them; for it is to such as these that the kingdom of God belongs” (Mark 10:14). Mark and Luke add Jesus’s saying, “Truly I tell you, whoever does not receive the kingdom of God as a little child will never enter it” (Mark 10:15 // Luke 18:17)."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn14",
      "id": "fn14"
    }
  }, [_vm._v("14")]), _vm._v(" Given the notable influence of Jesus on the personal relations of his disciples, we should probably detect the influence of Jesus here too in the “household codes” that appear in the later Pauline letters."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn15",
      "id": "fn15"
    }
  }, [_vm._v("15")])]), _vm._v(" Such household codes were familiar then, but notable in Paul’s exhortations is the assumption that children and slaves would be fully part of the Christian gathering and could or should be addressed directly. It is hardly straining the evidence to infer that this too attests the continuing influence of Jesus’s mission on his disciples.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Relaxation of Food Laws")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This is one of the most remarkable features of Jesus’s mission, not least since it cut so sharply across a traditional Jewish concern for purity. Not surprisingly it is given extensive treatment by Mark and Matthew (Mark 7:1–23 // Matt 15:1–20). It begins with some Pharisees’ criticism that Jesus’s disciples “ate with hands defiled, that is, unwashed.” The Greek word used here ("), _c('i', [_vm._v("koinos")]), _vm._v(" = “common”) reflects the distinctively Jewish sense of “profane, unclean, defiled.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn16",
      "id": "fn16"
    }
  }, [_vm._v("16")])]), _vm._v(" Jesus responds by citing Isaiah 29:13: “This people honors me with their lips, but their hearts are far from me; in vain do they worship me, teaching human precepts as doctrines.” And from that "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("he draws the highly critical conclusion: “You abandon the commandment of God and hold to human tradition” (Mark 7:6–8).")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("The Jesus tradition continues in both Mark and Matthew, by further challenging the traditional Jewish concept of purity (Matt 15:10–20 // Mark 7:14–23). The Matthean version of the tradition is content to draw a sharp comparison between inner and outer purity: “It is not what goes into the mouth that defiles a person, but it is what comes out of the mouth that defiles” (Matt 15:11)."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn17",
      "id": "fn17"
    }
  }, [_vm._v("17")]), _vm._v(" But in Mark the teaching is sharper: “There is nothing outside a person that by going in can defile, but the things that come out are what defile [a person]” (Mark 7:15). And in the following explanation that Jesus gives, it is clear that Jesus is remembered as teaching that what goes into a person cannot defile the person. Mark makes the point clear by adding, “Thus he declared all foods clean” (Mark 7:18–19).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("We know from Paul that the issue of clean and unclean foods came alive in the wider gentile mission. The issue there was whether Jesus’s followers could eat meat that had been sacrificed to idols (the most common supply of food in the ancient meat markets)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn18",
      "id": "fn18"
    }
  }, [_vm._v("18")])]), _vm._v(" Paul’s advice was clear: “Nothing is unclean in itself; but it is unclean for anyone who thinks it unclean” (Rom 14:14). What is intriguing is that Mark’s version of Jesus’s teaching on the subject of food purity seems to reflect the strong affirmation of Paul. In other words, it is in this teaching in particular that we can see the influence of Jesus’s priorities being further reflected on by Paul, and the inferences drawn from his teaching being reflected back into the memory of his teaching.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Last Supper or Lord’s Supper")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Finally, in recounting what Christianity learned from Jesus, we should not forget the centrality in the first Christians’ memory "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("and practice of Jesus’s last meal with his disciples before his death. The first three Gospels make plain how important that special time with Jesus was for his disciples (Mark 14:22–25 parr.). We do not know how frequently the Lord’s Supper was celebrated in the earliest decades of Christianity. But Paul makes it equally clear that the shared meal, beginning with the shared bread (“This is my body that is broken for you”) and ending with the shared cup (“This cup is the new covenant in my blood”), was explicitly remembered as a sacred memory initiated by Jesus himself (1 Cor 11:23–26). It sums up as nothing else does that Christianity is deeply rooted in Jesus’s own ministry climaxing in his death.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("It is striking, then, how much of what was important for the first Christians can be traced back directly to the influence of Jesus’s own ministry and teaching.")]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_vm._v("Distinctive Features of Jesus’s Ministry")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("For much or indeed most of the twentieth century, primary attention in scholarship on Jesus was given to what the first Christians thought about Jesus. Surprisingly little attention or concern was devoted to the impact made by Jesus himself, to such an extent that it could easily be concluded that little can now be discerned of the historical Jesus and his teaching. But the probability that Jesus made an impact on his first disciples, and that this impact is clearly indicated in the Jesus tradition, is such an obvious starting point that any scholarship that denies our ability to speak with credibility of the teaching and ministry of Jesus would seem to be unduly skeptical and prejudiced. We have already noted how much in earliest Christianity can be attributed with confidence to the influence of Jesus’s conduct and teaching. Now it can be added that not least of significance is the fact that there are distinctive features of Jesus’s ministry that stand out in the accounts of Jesus’s ministry and that cannot plausibly be said to have originated in later evaluations of his ministry.")])]), _c('p', {
    staticClass: "H2"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("The Kingdom of God")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("When we read the first three Gospels, it is easy and quite natural to conclude that proclamation of the kingdom of God was the principal feature of Jesus’s preaching. Mark introduces and sums up Jesus’s preaching in precisely these terms: “The time is fulfilled, and the kingdom of God has come near; repent, and believe in the good news” (Mark 1:15). Matthew and Luke both summarize Jesus’s preaching in the same terms: Jesus “went throughout Galilee . . . proclaiming the gospel of the kingdom” (Matt 4:23). Jesus said to his disciples, “I must proclaim the good news of the kingdom of God to the other cities also” (Luke 4:43). When Jesus sent out his disciples in mission, it was to proclaim the same message: “The kingdom of heaven has come near” (Matt 10:7 // Luke 10:9). A notable example of his kingdom preaching is the first item of Jesus’s beatitudes or blessings: “Blessed are you who are poor, for yours is the kingdom of God” (Luke 6:20 // Matt 5:3). Also prominent is Jesus’s claim that his healing ministry was itself a manifestation of the kingdom: “If it is by the Spirit of God that I cast out demons, then the kingdom of God has come to you” (Matt 12:28 // Luke 11:20). And notable too are Jesus’s kingdom parables: for example, “[The kingdom of God] is like a mustard seed” (Mark 4:31 parr.).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("It is easy to see, then, that Jesus’s preaching ministry can be summed up in terms of his proclamation of the kingdom of God, not only imminent but already in evidence in his ministry. The kingdom of God (or, of heaven, in Matthew’s preferred version) is mentioned more than fifty times in the tradition shared by the first three written Gospels. This makes it all the more astonishing that references to the kingdom of God thereafter are so thin. For example, Paul picks up the theme of inheriting the kingdom of God,"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn19",
      "id": "fn19"
    }
  }, [_vm._v("19")]), _vm._v(" but the thought of the kingdom as present and active is hardly a strong feature of his gospel, as it was of Jesus’s ministry."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn20",
      "id": "fn20"
    }
  }, [_vm._v("20")])]), _vm._v(" And, astonishingly when compared with the other Gospels, "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("the Gospel of John has Jesus referring to God’s kingdom in only one pericope (John 3:3, 5), though John also includes Jesus referring to “my kingdom” in his trial before Pilate (John 18:36). The evidence, then, indicates that it is highly unlikely that memory and reworking of the Jesus tradition picked up the emphasis on the kingdom of God from later Christian interest in the theme. It is much more likely that Jesus’s emphasis on the kingdom of God was slackened among his followers thereafter, presumably because in a Roman Empire alive to threats against its authority, promotion of any other kingdom could be presented as such a threat. Jesus’s proclamation of God’s kingdom was not a theme to be elaborated in Caesar’s empire.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "H2"
  }, [_vm._v("Teacher")])]), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Teacher is the most common title used for Jesus in the Jesus tradition—occurring nearly fifty times. The parallel between Jesus and his disciples on the one hand and rabbis and their pupils on the other hand is only partial, but the very fact that the immediate followers of Jesus were known as “disciples” ("), _c('i', [_vm._v("mathētēs")]), _vm._v(", from "), _c('i', [_vm._v("manthanein")]), _vm._v(", “to learn”) certainly implies that Jesus was widely recognized as a teacher whose disciples followed him in order to learn."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn21",
      "id": "fn21"
    }
  }, [_vm._v("21")]), _vm._v(" Indeed, it is remembered that Jesus was occasionally addressed as “Rabbi” or “Rabbouni,”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn22",
      "id": "fn22"
    }
  }, [_vm._v("22")])]), _vm._v(" and Matthew recalls that Jesus himself saw his relationship with his disciples in these terms (Matt 10:24–25 // Luke 6:40).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("One of the features remembered about his teaching was the surprising authority with which he taught. He is recalled as one who provoked surprise and questioning concerning the authority of his teaching. For example, Mark characteristically links Jesus’s teaching with his exorcisms and mighty works: “What is this? A "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("new teaching—with authority! He commands even the unclean spirits and they obey him” (Mark 1:27). “Where did this man get all this? What is this wisdom that has been given to him? What deeds of power are being done by his hands!” (Mark 6:2). The high priestly delegation asked him, “By what authority are you doing these things? Who gave you this authority?” (Mark 11:28 parr.). Such surprise, even incredulity, is understandable given the presumably well-enough-known fact that Jesus lacked any formal training. It is all the more striking, then, that this emphasis on Jesus as a teacher is not retained among the earliest churches. Of course, Jesus was remembered as far more than a teacher in the earliest churches. But that very fact makes it all the less credible to argue that the references to Jesus as “teacher” were read back into the Jesus tradition. The fact that Jesus was widely known as a teacher during his ministry is one of the most firmly established features of the Jesus tradition.")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "H2"
  }, [_vm._v("Teaching by Parable")])]), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("It was also one of the most distinctive features of Jesus’s ministry that he was a parabolist. Stories, illustrations, or parables were not regular features of passing on traditional teaching within Judaism. So it is rather striking that Mark, at the end of his parable collection (Mark 4:1–32), sums up his portrayal of Jesus in these terms: “With many such parables he spoke the word to them, as they were able to hear it; he did not speak to them except in parables, but he explained everything in private to his disciples” (Mark 4:33–34 // Matt 13:34). Indeed, no fewer than forty-six parables are attributed to Jesus in the shared tradition—some featuring in all of the first three Gospels, like the sower (Mark 4:1–9, 13–20 parr.) and the wicked tenants (Mark 12:1–12 parr.); some probably in the tradition common to Matthew and Luke, like the parable of the talents (Matt 25:14–30 // Luke 19:11–27); some unique to Matthew, like the parables of the laborers in the vineyard (Matt 20:1–16) and the wise and foolish maidens (Matt 25:1–13); and over a third of the total distinctive of Luke, including some of the ")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("best known, such as the good Samaritan (Luke 10:25–37), the lost sheep, the lost coin, the lost son (Luke 15:1–32), the rich man and Lazarus (Luke 16:19–31), and the Pharisee and the tax collector (Luke 18:9–14). So the description of Jesus as a parabolist is well founded.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("What is striking in comparison is that no one else among the disciples of Jesus or in the earliest churches is remembered as a parabolist. Paul, for example, is remembered for some vivid analogies, such as the olive tree with grafted branches (Rom 11:17–24), but he is hardly remembered as a parabolist. And, remarkably, John makes no effort to portray Jesus as a teller of parables; the “I am” sayings, particularly “I am the true vine” (John 15:1), are as near as he gets. So it would be very hard to maintain an argument that the portrayal of Jesus as a parabolist was anachronistically applied by the first Christians or the first three evangelists to the Jesus tradition. The only obvious explanation is that even if Jesus did not initiate a model of teaching followed by his disciples, we have to conclude at the very least that he was warmly remembered as one who typically taught by telling parables and that his parables made a lasting impression on his disciples.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Exorcising Evil Spirits")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Exorcism was evidently one of the most prominent features of Jesus’s ministry. We may note, for example, the accusation leveled against Jesus that he cast out demons “by the ruler of the demons” (Mark 3:22 parr.). To which Jesus responded: “How can Satan cast out Satan? If a kingdom is divided against itself, that kingdom cannot stand. And if a house is divided against itself, that house will not be able to stand. And if Satan has risen up against himself and is divided, he cannot stand, but his end has come. But no one can enter a strong man’s house and plunder his property without first tying up the strong man; then indeed the house can be plundered” (Mark 3:23–27 parr.).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("At this point Matthew and Luke insert a passage from their shared source appropriately: “If I cast out demons by Beelzebul, ")]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("by whom do your sons cast them out? Therefore they shall be your judges. But if it is by the Spirit of God that I cast out demons, then the kingdom of God has come to you” (Matt 12:27–28 // Luke 11:19–20). It is evident, then, that Jesus was widely regarded as an exorcist."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn23",
      "id": "fn23"
    }
  }, [_vm._v("23")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("According to the first three evangelists, Jesus also commissioned his disciples to preach and to cast out demons."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn24",
      "id": "fn24"
    }
  }, [_vm._v("24")])]), _vm._v(" And, quite unexpectedly,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn25",
      "id": "fn25"
    }
  }, [_vm._v("25")])]), _vm._v(" when thus sent out, they seem to have been as successful as Jesus himself (Luke 10:17). It is somewhat surprising, then, that exorcism does not feature at all in the earliest churches. The term "), _c('i', [_vm._v("daimonion")]), _vm._v(" (“daemon” or “evil spirit”) occurs sixty-seven times in the tradition shared by Mark, Matthew, and Luke, but only six times in John, and occasionally thereafter; but exorcisms as such are never mentioned again."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn26",
      "id": "fn26"
    }
  }, [_vm._v("26")])]), _vm._v(" Casting out demons was evidently not a ministry that the first Christians exercised, despite having Jesus himself as their precedent. And if they did, they evidently did not think it worth recording. Either way, it is incredible to infer that Jesus’s ministry as an exorcist was entirely read back into the Jesus tradition. Here too we can be confident that Jesus was known and remembered as a successful exorcist.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Concentration on Galilee")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("One of the curiosities that any comparison of the Gospel of John with the first three Gospels can hardly miss is that so much of John’s account of Jesus’s ministry is set in the south, in Judea and Jerusalem. In Mark, Matthew, and Luke the story of Jesus’s ministry is clear. He was baptized by the Baptist in Judea. But after John was arrested and imprisoned, Jesus withdrew to the north, "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("to Galilee (Mark 1:14 parr.). And there he ministered for the bulk of his ministry. It was only after Peter’s confession of Jesus as the Messiah,"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn27",
      "id": "fn27"
    }
  }, [_vm._v("27")]), _vm._v(" says Matthew, that Jesus “began to show his disciples that he must go to Jerusalem and undergo great suffering” there (Matt 16:21). Luke tells the same story: “When the days drew near for him to be taken up, he set his face to go to Jerusalem” (Luke 9:51). And it is generally recognized that the passion narrative begins with Jesus’s entry into Jerusalem (Mark 11:1–10 parr.).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In contrast, John has Jesus going up to Jerusalem several times in the course of his ministry. John portrays Jesus as “cleansing the temple” early on (John 2:13–22), followed by his conversation with Nicodemus while he is still in Jerusalem (John 2:23–3:10). Jesus lingers in Judea and ministers effectively in Samaria (John 3:22–4:42), followed by an apparently brief spell in Galilee (John 4:43–54). In chapter 5 he is once again in Jerusalem, but in chapter 6 he is rather abruptly back in Galilee for the great bread of life discourse. Shortly after that, however, he again goes up to Jerusalem (John 7:10), and, surprisingly, he never returns to Galilee thereafter. John in fact highlights the degree of surprise that his portrayal causes by mentioning the disbelief of the Jerusalem crowd that any good could come from Galilee (John 7:41, 52).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is easy to see how the contrast between the first three Gospels and John came about. For whatever reason, Mark, who first composed a “gospel” (Mark 1:1), decided to focus on Jesus’s ministry in Galilee and to portray his trip to Jerusalem, with his betrayal, crucifixion, and resurrection, as the climax. In this he was followed by Matthew and Luke, both using Mark as their template. John, however, suggests that Jesus in fact made earlier trips to Jerusalem, to take part in annual festivals, prior to his final journey climaxing in his passion. The issue is complicated by John’s transfer of the cleansing of the temple episode to the beginning of Jesus’s ministry, probably as a “sign” to indicate the character of his ministry (John 2:18–22). But that may simply remind us that John saw his attempt to bring out the significance of Jesus’s mission "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("as different from and as less constrained by historical detail than the earlier evangelists. Either way, both bring out distinctives of Jesus’s ministry as it was variously remembered.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "H2"
  }, [_vm._v("Submission to High Priestly Authorities")])]), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("We should simply note that Jesus was remembered as in effect willingly surrendering himself to the Jerusalem authorities. As we saw in the last section, the first three Gospels make Jesus’s decision to go to Jerusalem the turning point in their respective tellings of the story of Jesus. Mark sets the scene by showing Jesus making a sequence of passion predictions in (what are now) successive chapters."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn28",
      "id": "fn28"
    }
  }, [_vm._v("28")]), _vm._v(" The third is the most explicit: “The Son of Man will be handed over to the chief priests and the scribes, and they will condemn him to death; then they will hand him over to the Gentiles; they will mock him, and spit upon him, and flog him, and kill him; and after three days he will rise again” (Mark 10:33–34).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("What is striking, and can be listed as another distinctive of Jesus’s ministry, is that Jesus is thus remembered as going willingly and knowingly to his betrayal and death in Jerusalem. This is in some contrast to his withdrawal from danger after Herod’s execution of John the Baptist (Matt 14:13 parr.). The way in which the evangelists set out their accounts of the good news, beginning with the baptism by John, subsequently to be executed, and with early warning indications (such as Mark 3:6), shows that the characterization of the gospels as “passion narratives with an extended introduction”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn29",
      "id": "fn29"
    }
  }, [_vm._v("29")])]), _vm._v(" faithfully represents a ministry that climaxed in submission to the Jerusalem authorities.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is not difficult, then, to see these features as distinctive of Jesus’s actual ministry—none of them first read back into the Jesus tradition at a subsequent date, but each of them truly remembered by his disciples, having made a lasting impact on "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("them, and providing core features of their retelling of the story of that ministry.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "H1"
  }, [_vm._v("Jesus’s Self-Understanding")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Not least amazing is the fact that we can discern Jesus’s own understanding of his role, and can do so quite clearly behind what the first Christians subsequently thought of him. Of course, the Gospels portray Jesus as he was seen in the light of all that happened in the climax of his ministry and thereafter. But we have already seen how much of what the first believers said regarding Jesus’s mission can be realistically explained only in terms of the impact Jesus made on his disciples during his mission. And so it is when we ask what we can know with confidence about Jesus’s own self-awareness. The evidence can be listed quite concisely.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Jesus’s Baptismal Commission")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("All the evangelists agree that Jesus began his mission following his baptism by John the Baptist (Mark 1:9–11 parr.). The fact that Jesus was baptized by John, implying that John was in effect senior to Jesus, was something of an embarrassment for the first Christians. Matthew indicates this by adding that John tried to prevent Jesus, saying to Jesus, “I need to be baptized by you, and do you come to me?” He only consents to baptize Jesus when Jesus replies, “Let it be so now; for it is proper for us in this way to fulfill all righteousness” (Matt 3:14–15). The point is that it was too fixed in the first followers’ memory of Jesus that his mission began after his baptism by John, so that the event could hardly be ignored.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Fundamental to the earliest memory of that event was the understanding that it was then that Jesus received the affirmation of God’s favor and an anointing with God’s Spirit for the mission that he thereafter lived out. Whether it was a private commission, as Mark 1:10–11 implies, or something more public (Matt 3:16–17 ")]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("// Luke 3:21–22), is less important than the agreed testimony of all the evangelists that Jesus’s mission began from a commissioning that he received from God, his Father, when he was baptized by John.")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "H2"
  }, [_vm._v(" “I Came” or “I Was Sent”")])]), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Jesus’s sense of being heavenly commissioned (at his baptism by John) is attested by the number of times when he expresses that conviction. So, for example: “I have come to call not the righteous but sinners” (Mark 2:17 parr.); “I came to bring fire to the earth”;"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn30",
      "id": "fn30"
    }
  }, [_vm._v("30")]), _vm._v(" “the Son of Man came . . . to serve” (Mark 10:45 par.)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn31",
      "id": "fn31"
    }
  }, [_vm._v("31")])]), _vm._v(" Or again: “whoever welcomes me welcomes . . . the one who sent me” (Mark 9:37 // Luke 9:48); “whoever welcomes me welcomes the one who sent me” (Matt 10:40 // John 13:20); “whoever rejects me rejects the one who sent me” (Luke 10:16). Of some interest is the fact that John elaborates the “sent” tradition,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn32",
      "id": "fn32"
    }
  }, [_vm._v("32")])]), _vm._v(" indicating one of the principal roots of his more elaborate Christology. But it is clear enough that this elaboration is well rooted in the earliest memories of one who at least occasionally expressed his sense of heavenly commission in these terms. As a feature distinctive of the Gospels within the New Testament, its origin can hardly be attributed to the later believers.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Messiah/Christ")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("That Jesus was the long-expected Messiah is the direct implication of the information just noted. The claim is fundamental to the structure of the first three Gospels, following the lead of Mark. Although Jesus was initially hailed by demoniacs as Messiah,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn33",
      "id": "fn33"
    }
  }, [_vm._v("33")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("Mark’s account centers on Peter’s confession (Mark 8:29) and climaxes in Jesus’s condemnation by Pilate as “king of the Jews” (Mark 15:9–26). Because such a claim was liable to be misunderstood (in terms of political leadership), Mark shows Jesus keeping the claim quiet (Mark 1:25; 3:12) until (as already noted) he could explain that messiahship meant suffering and death, but also resurrection."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn34",
      "id": "fn34"
    }
  }, [_vm._v("34")]), _vm._v(" John’s retelling of the story of Jesus’s mission, in contrast, shows no such inhibitions."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn35",
      "id": "fn35"
    }
  }, [_vm._v("35")])]), _vm._v(" There is no reason to doubt either that the question whether Jesus was the long-expected Messiah was raised by and during Jesus’s mission, or that Jesus understood his mission in these terms, or that he was crucified as a pretentious Messiah. What is particularly interesting is that in the subsequent early Christian usage, “Christ” had already become a proper name—“Jesus Christ”—even leaving behind the affirmation “Jesus, the Christ.” This suggests that the claim that Jesus was (the) Messiah was already deeply rooted at the beginnings of Christianity and entirely reflective of the messianic claim that Jesus’s own mission embodied.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Abba")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The Jesus tradition is quite clear that Jesus addressed God as “Father” in his prayers. All five strata of the Gospel material are unanimous on this point."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn36",
      "id": "fn36"
    }
  }, [_vm._v("36")])]), _vm._v(" There are also good grounds for the further conclusion that Jesus used the Aramaic address, “Abba.” The use of this term is explicitly attested in the Jesus tradition only in Mark 14:36. But since Matthew and Luke both read the Greek vocative "), _c('i', [_vm._v("pater")]), _vm._v(" at this point (Matt 26:39 // Luke 22:42), the probability is that underlying the vocative "), _c('i', [_vm._v("pater")]), _vm._v(" in the other prayers of Jesus (including the Lord’s Prayer [Luke 11:2]) was the Aramaic "), _c('i', [_vm._v("abba")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("What is remarkable is that, according to Paul, the early Christians also used this intimate form of address in their prayers."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn37",
      "id": "fn37"
    }
  }, [_vm._v("37")]), _vm._v(" They attributed it to the Holy Spirit and saw it as attesting that they too were children, a status shared with Christ. The fact that the gentile (Greek-speaking) believers to whom Paul was writing regularly used this Aramaic prayer form attests how well established this form of prayer had become in the early churches. And the fact that it was seen as attesting a sonship shared with Christ is itself confirmation that the prayer language was knowingly echoing Jesus’s own usage. In other words, the obvious conclusion is that the Abba prayer was so cherished among the first believers precisely because it was remembered as being Jesus’s own prayer form. It was precisely because “Abba” was Jesus’s own way of praying that their use of it served as assurance that they shared in his sonship.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Son of God")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("It is evident that Jesus was remembered as God’s son by his disciples more or less from the beginning. They clearly saw his baptism in the Jordan as the occasion when he was hailed as God’s “beloved son” by a heavenly voice (Mark 1:11 parr.), perhaps even as the day when he was “begotten” as God’s son, as a variant text of Luke 3:22 (citing Ps 2:7) suggests. And the temptation narrative in Matthew 4 and Luke 4 focuses on precisely that status: “If you are the Son of God” (Matt 4:3, 6 // Luke 4:3, 9). Moreover, demoniacs are recalled as hailing Jesus as God’s son (as in Mark 5:7 parr.).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But did Jesus see himself in these terms? The evidence is not as strong as we would like. The strongest self-testimony, Matthew 11:27 // Luke 10:22, is exceptional within the tradition shared by the first three Gospels. And one can hardly help wondering whether reference to “the Son” is a later addition to Mark 13:32 // Matthew 24:36. More plausible is the evidence of the parable of the wicked husbandmen (Mark 12:1–9 parr.), since, as we have "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("seen, parables were a form of teaching unique to Jesus. The fact that the vineyard owner’s son is killed could be a reflection of what subsequently happened to Jesus, though the absence of a clear reference to Jesus’s resurrection in the parable itself suggests that its original telling expressed Jesus’s own anticipation of the likely outcome of his ministry. But it does appear that the key point in the trial of Jesus was the accusation that he had claimed to be “the Christ, the son of the Blessed” (Mark 14:61). Intriguing is the fact that Matthew and Luke depict Jesus as not giving a straightforward positive answer to the accusation (Matt 26:64 // Luke 22:67–70), but nevertheless it was the charge of blasphemy that was the ground of Jesus being condemned to death. All this, along with the “Abba” evidence reviewed above, indicates that it is certainly more than plausible to deduce that the earliest Christian belief that Jesus was uniquely God’s son was rooted in the earliest memories of his mission and death.")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "H2"
  }, [_vm._v("The Son of Man")])]), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("The phrase “the Son of Man” occurs eighty-six times in the NT. Sixty-nine occur in the first three Gospels, and thirteen occur in John. Of the remaining four instances, three are quotations from or allusions to OT passages"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn38",
      "id": "fn38"
    }
  }, [_vm._v("38")]), _vm._v(" and show no awareness of the Gospel usage. Only one titular usage (“the Son of Man”) appears outside the Gospels—in Stephen’s vision in Acts 7:56. Even more striking is the fact that in all four Gospels the phrase appears "), _c('i', [_vm._v("only")]), _vm._v(" on the lips of Jesus. He is never addressed or confessed as “Son of Man,” neither in the Gospel narratives nor subsequently in the churches’ worship. This is in marked contrast with other titles for Jesus. Some examples:")]), _vm._v(" "), _c('table', {
    staticClass: "Table1",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Mark 2:10 parr.")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("“That you may know that the Son of Man has authority on earth to forgive sins.”")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Mark 2:28 parr.")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("“The Son of Man is lord even of the sabbath.”")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Matt 8:20 // Luke 9:58")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("“Foxes have holes, and birds of the air have nests; but the Son of Man has nowhere to lay his head.”")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Matt 11:18–19 // Luke 7:33–34")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("“John came neither eating nor drinking, and they say, ‘He has a demon’; the Son of Man came eating and drinking, and they say, ‘Look, a glutton and a drunkard.’ ”")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("The conclusion is obvious: this particular speech usage was remembered as distinctive of Jesus precisely because that is what it was. Moreover, the several occasions on which one evangelist has “the Son of Man” while another has “I” make it clear that Jesus’s first disciples recognized the phrase as a self-reference,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn39",
      "id": "fn39"
    }
  }, [_vm._v("39")])]), _vm._v(" and one that was so distinctive of Jesus’s own speech that it did not function as a title for Jesus in the earliest Christology of the churches. That Jesus may also have been influenced by the great vision of Daniel 7:13 hardly affects the issue,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn40",
      "id": "fn40"
    }
  }, [_vm._v("40")])]), _vm._v(" though it is interesting that subsequent Christology did not make more of it. Again, the most obvious deduction is that Jesus himself was more influenced by Daniel 7:13 in the way he envisaged his ministry working out than were his immediate and subsequent disciples.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Jesus’s Self-Expectation")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The testimony of the Gospels is clear: Jesus fully expected death at the hands of the civil authorities (the Romans), but he also expected to be vindicated. Mark provides early hints: the warning "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("that he would be taken away from his disciples (Mark 2:20) and the surprisingly early indication that the Pharisees were out to get him (Mark 3:6). But the main weight of Jesus’s expectation is carried by the three passion predictions that follow Peter’s confession that Jesus was the Messiah (Mark 8:29).")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "EX"
  }, [_vm._v("Then he began to teach them that the Son of Man must undergo great suffering, and be rejected by the elders, the chief priests, and the scribes, and be killed, and after three days rise again. (Mark 8:31)")]), _vm._v(" "), _c('p', {
    staticClass: "EX1"
  }, [_vm._v("He was teaching his disciples, saying to them, “The Son of Man is to be betrayed into human hands, and they will kill him, and three days after being killed, he will rise again.” (Mark 9:31)")]), _vm._v(" "), _c('p', {
    staticClass: "EX1"
  }, [_vm._v("He took the twelve aside agian and began to tell them what was to happen to him, saying, “See, we are going up to Jerusalem, and the Son of Man will be handed over to the chief priests and the scribes, and they will condemn him to death; then they will hand him over to the Gentiles; they will mock him, and spit upon him, and flog him, and kill him; and after three days he will rise again.” (Mark 10:32–34)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The fact that, despite such forewarnings, Jesus’s disciples seem to have been totally unprepared for Jesus’s betrayal and arrest (Mark 14:50) hardly diminishes the likelihood that Jesus himself had at least clear forebodings, even if what actually happened to Jesus understandably colored their memory of such predictions or forewarnings (as is likely in the case of Mark 10:34). For, as we have seen, there is little reason to doubt that Jesus himself was clear on the probability that his journey to Jerusalem would end with his rejection and death. So, here too we can detect clear echoes of Jesus’s own self-understanding and conception of his mission.")])]), _c('p', {
    staticClass: "Orn"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("*"), _c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "space1"
  }, [_vm._v("*"), _c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "space1"
  }, [_vm._v("*")])])])])])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("There has been a tradition of scholarly skepticism stretching back two generations that very little can be said of Jesus’s own self-understanding since most or almost all of the significance attributed to Jesus by the first Christians was read back by them into the memories of his prepassion mission. However, we have seen how much of Jesus’s message can be attributed confidently to Jesus himself. There is in fact no good reason to deny that what has been reviewed above was rooted in good and authentic memory that Jesus’s first disciples largely shared—not only the emphases and priorities that they learned from him but also the distinctive features of his ministry that they did not seek to imitate in their own ministries, and particularly what were remembered as statements and claims that revealed Jesus’s own understanding of his mission and of his role. At the very least, then, we can say that the roots of the subsequent beliefs about Jesus were well established in what he was (and is) remembered as having said and how he acted. Jesus according to Jesus is firmly at the root of Jesus according to the evangelists.")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('img', {
    attrs: {
      "alt": "line",
      "src": "images/line1.jpg"
    }
  })])]), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn1",
      "id": "rfn1"
    }
  }, [_vm._v("1")]), _vm._v(". John P. Meier, "), _c('i', [_vm._v("A Marginal Jew: Rethinking the Historical Jesus")]), _vm._v(", 5 vols. (New Haven: Yale University Press, 1991–2016).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn2",
      "id": "rfn2"
    }
  }, [_vm._v("2")]), _vm._v(". The writers of the Gospels are often referred to as “evangelists” (“evangel” = “gospel”).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn3",
      "id": "rfn3"
    }
  }, [_vm._v("3")]), _vm._v(". I have restricted the footnotes to a minimum. For more detailed discussion, see James D. G. Dunn, "), _c('i', [_vm._v("Jesus Remembered")]), _vm._v(", vol. 1 of "), _c('i', [_vm._v("Christianity in the Making")]), _vm._v(" (Grand Rapids: Eerdmans, 2003). The content of this chapter has been adapted from this earlier work.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn4",
      "id": "rfn4"
    }
  }, [_vm._v("4")]), _vm._v(". Mark 12:28–31 // Matt 22:35–40 // Luke 10:25–28.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn5",
      "id": "rfn5"
    }
  }, [_vm._v("5")]), _vm._v(". Unless otherwise indicated, biblical quotations are either from the New Revised Standard Version or are the author’s own translation.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn6",
      "id": "rfn6"
    }
  }, [_vm._v("6")]), _vm._v(". Sifra on Lev 19:18.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn7",
      "id": "rfn7"
    }
  }, [_vm._v("7")]), _vm._v(". Rom 13:8–10; Gal 5:14; Jas 2:8; Didache 1:2; 2:7; Barnabas 19:5; Gospel of Thomas 25.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn8",
      "id": "rfn8"
    }
  }, [_vm._v("8")]), _vm._v(". Rom 15:25–31; 2 Cor 8–9.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn9",
      "id": "rfn9"
    }
  }, [_vm._v("9")]), _vm._v(". Q is one of the sources on which Matthew and Luke drew. For more on Q, see chapter 2.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn10",
      "id": "rfn10"
    }
  }, [_vm._v("10")]), _vm._v(". The equivalent passage in John’s Gospel is John 12:20–26, though the point is not so clearly made.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn11",
      "id": "rfn11"
    }
  }, [_vm._v("11")]), _vm._v(". The parallels in Matthew and Luke are not so full (Matt 27:55–56 and Luke 23:49).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn12",
      "id": "rfn12"
    }
  }, [_vm._v("12")]), _vm._v(". Matt 27:55–56; John 20:11–18.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn13",
      "id": "rfn13"
    }
  }, [_vm._v("13")]), _vm._v(". See James D. G. Dunn, "), _c('i', [_vm._v("Beginning from Jerusalem")]), _vm._v(", vol. 2 of "), _c('i', [_vm._v("Christianity in the Making")]), _vm._v(" (Grand Rapids: Eerdmans, 2009), 571.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn14",
      "id": "rfn14"
    }
  }, [_vm._v("14")]), _vm._v(". Matthew includes a variation of the saying earlier (Matt 18:3).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn15",
      "id": "rfn15"
    }
  }, [_vm._v("15")]), _vm._v(". Eph 6:1–9; Col 3:18–4:1.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn16",
      "id": "rfn16"
    }
  }, [_vm._v("16")]), _vm._v(". Dunn, "), _c('i', [_vm._v("Jesus Remembered")]), _vm._v(", 571n123.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn17",
      "id": "rfn17"
    }
  }, [_vm._v("17")]), _vm._v(". Matthew and Luke (Q) also recall Jesus rebuking Pharisees for counting outward cleanliness as more important than inward cleanliness (Matt 23:25–26 // Luke 11:39–41).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn18",
      "id": "rfn18"
    }
  }, [_vm._v("18")]), _vm._v(". Rom 14:1–15:6; 1 Cor 8–10.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn19",
      "id": "rfn19"
    }
  }, [_vm._v("19")]), _vm._v(". 1 Cor 6:9; 15:10; Gal 5:21; Eph 5:5.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn20",
      "id": "rfn20"
    }
  }, [_vm._v("20")]), _vm._v(". Rom 14:17; 1 Cor 4:20; Col 1:13.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn21",
      "id": "rfn21"
    }
  }, [_vm._v("21")]), _vm._v(". "), _c('i', [_vm._v("Mathētēs")]), _vm._v(" (disciple) is used frequently in the Gospels—seventy-three times in Matthew, forty-six times in Mark, thirty-seven times in Luke, and seventy-eight times in John.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn22",
      "id": "rfn22"
    }
  }, [_vm._v("22")]), _vm._v(". Mark 9:5; 10:51; 11:21; 14:45; Matt 26:25; John 1:38, 49; 3:2; 4:31; 6:25; 9:2; 11:8.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn23",
      "id": "rfn23"
    }
  }, [_vm._v("23")]), _vm._v(". Matt 9:32–34; 17:18; Mark 1:34, 39; 7:26–30; Luke 4:33–35, 41; 8:27–38; 9:42; 11:14–15; 13:32.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn24",
      "id": "rfn24"
    }
  }, [_vm._v("24")]), _vm._v(". Mark 3:15; 6:7–13 parr.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn25",
      "id": "rfn25"
    }
  }, [_vm._v("25")]), _vm._v(". Cf. Mark 9:18 parr.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn26",
      "id": "rfn26"
    }
  }, [_vm._v("26")]), _vm._v(". Outside the first three Gospels, curing someone possessed by an “unclean spirit,” as an alternative expression, appears only in Acts 5:16 and 8:7.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn27",
      "id": "rfn27"
    }
  }, [_vm._v("27")]), _vm._v(". “Messiah” (= "), _c('i', [_vm._v("christos")]), _vm._v(" in Greek) was the title of Israel’s longed-for deliverer.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn28",
      "id": "rfn28"
    }
  }, [_vm._v("28")]), _vm._v(". Mark 8:31; 9:31; 10:33–34.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn29",
      "id": "rfn29"
    }
  }, [_vm._v("29")]), _vm._v(". See the discussion of Martin Kähler in the next chapter.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn30",
      "id": "rfn30"
    }
  }, [_vm._v("30")]), _vm._v(". Luke 12:49, 51–53; cf. Matt 10:34–36.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn31",
      "id": "rfn31"
    }
  }, [_vm._v("31")]), _vm._v(". See also Mark 1:38 // Luke 4:43 (“I was sent”); Matt 11:18–19 // Luke 7:33–34; Matt 5:17; Luke 19:10.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn32",
      "id": "rfn32"
    }
  }, [_vm._v("32")]), _vm._v(". John 3:17, 34; 5:36, 38; 6:29, 57; 7:29; 8:42; 11:42; 17:3, 8, 21, 23, 25; 20:21.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn33",
      "id": "rfn33"
    }
  }, [_vm._v("33")]), _vm._v(". Mark 1:24; 3:11.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn34",
      "id": "rfn34"
    }
  }, [_vm._v("34")]), _vm._v(". Mark 8:31; 9:31; 10:33–34.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn35",
      "id": "rfn35"
    }
  }, [_vm._v("35")]), _vm._v(". John 1:41; 4:25–26, 29.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn36",
      "id": "rfn36"
    }
  }, [_vm._v("36")]), _vm._v(". Q (the source shared by Matthew and Luke)—Matt 11:25–26 // Luke 10:21; Mark 14:36 parr.; Matt 26:42; Luke 23:34, 46; John 11:41; 12:27–28; 17:1, 5, 11, 21, 24–25.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn37",
      "id": "rfn37"
    }
  }, [_vm._v("37")]), _vm._v(". Rom 8:15–17; Gal 4:6–7.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn38",
      "id": "rfn38"
    }
  }, [_vm._v("38")]), _vm._v(". Heb 2:6 = Ps 8:4; Rev 1:13 and 14:14 alluding to Dan 7:13.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn39",
      "id": "rfn39"
    }
  }, [_vm._v("39")]), _vm._v(". Luke 6:22 // Matt 5:11; Luke 12:8 // Matt 10:32; Matt 16:13 // Mark 8:27; Mark 10:45 // Luke 12:27.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn40",
      "id": "rfn40"
    }
  }, [_vm._v("40")]), _vm._v(". Mark 13:26 parr.; 14:62 parr.; cf. 8:38 parr.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5aa5eff4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter001.vue
// module id = 75
// module chunks = 0